import type { CheckoutSessionsResponse } from '../../../../../services/commonCheckout/types/CheckoutSessionsResponse';

export const isManufacturerCardFeatureEnabledForMerchant = (
  initialSessionData: CheckoutSessionsResponse,
) =>
  !!initialSessionData.checkoutSession.checkoutRequest.config?.cardCategories?.some(
    (category) => category.type === 'MANUFACTURER_CARD',
  );
